import { useId } from "react";

// Explus Cleaning brand mark: a water drop whose negative space forms a capital
// "E", with a sparkle for cleanliness/premium quality. Subtle emerald gradient.
// Uses an evenodd knockout so the "E" shows the surface behind it (works on any
// background). gradient=false renders monochrome via currentColor (e.g. pure
// white over the hero image).
const DROP =
  "M24 3.5C24 3.5 36.5 17.5 36.5 28.5C36.5 35.6 30.9 41.5 24 41.5C17.1 41.5 11.5 35.6 11.5 28.5C11.5 17.5 24 3.5 24 3.5Z";
const E_CUTS =
  "M18.4 23h2.9v14h-2.9Z M21.3 23h8.5v2.9h-8.5Z M21.3 28.55h6.5v2.9h-6.5Z M21.3 34.1h8.5v2.9h-8.5Z";
const SPARKLE =
  "M37 4.2C37.3 7.4 37.8 7.9 41 8.2C37.8 8.5 37.3 9 37 12.2C36.7 9 36.2 8.5 33 8.2C36.2 7.9 36.7 7.4 37 4.2Z";

export function LogoMark({ className = "", gradient = true }) {
  const uid = useId().replace(/:/g, "");
  const gradId = `eg-${uid}`;
  const fill = gradient ? `url(#${gradId})` : "currentColor";
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true" role="img">
      <defs>
        <linearGradient id={gradId} x1="6" y1="4" x2="40" y2="42" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#34d399" />
          <stop offset="1" stopColor="#047857" />
        </linearGradient>
      </defs>
      <path d={`${DROP} ${E_CUTS}`} fillRule="evenodd" clipRule="evenodd" fill={fill} />
      <path d={SPARKLE} fill={fill} />
    </svg>
  );
}

export function Logo({ className = "", markClass = "w-7 h-7", textClass = "", gradient = true }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <LogoMark className={markClass} gradient={gradient} />
      <span className={`font-heading font-semibold tracking-tight ${textClass}`}>
        Explus <span className="font-normal text-emerald-600">Cleaning</span>
        <span className="align-top text-[0.5em] font-semibold tracking-wider text-emerald-600 ml-0.5">LLC</span>
      </span>
    </span>
  );
}
